import { EnvironmentFilled, LoadingOutlined } from '@ant-design/icons'
import { FormInput } from '@components/_SiteWide/Form/FormInput'
import {
  DataItem,
  EditSaveButton,
  ErrorNotification,
  LocationMap,
  NothingMessage,
  NotificationMessage,
} from '@gravitate-js/excalibrr'
import api from '@utils/api'
import { Col, Form, Row } from 'antd'
import React, { useEffect, useState } from 'react'

export function MapLocation({ store, loading, setLoading, canEditStores }) {
  const [editing, setEditing] = useState(store.id === 0 || (!store.lat && !store.lon) || false)
  const [currentStore, setCurrentStore] = useState(store)
  const [form] = Form.useForm()
  form.setFieldsValue({ ...currentStore })
  let mapCenter = {}

  useEffect(() => {
    setCurrentStore(store)
  }, [store, currentStore.lat, currentStore.lon])

  if (currentStore.id !== 0) mapCenter = { lat: currentStore.lat, lng: currentStore.lon }

  const handleSave = (formData) => {
    currentStore.lat = formData.lat
    currentStore.lon = formData.lon

    setLoading(true)
    if (currentStore.id === 0) {
      setLoading(false)
      NotificationMessage('Error Saving', 'Please enter and save Site Info before entering the map location')
      return
    }
    api
      .updateStore({
        id: currentStore.id,
        store_number: currentStore.store_number,
        market: currentStore.market,
        ...formData,
      })
      .then(() => {
        Object.assign(currentStore, formData)
        setEditing(false)
        setLoading(false)
      })
  }

  const googleMap = <LocationMap mapCenter={mapCenter} location={currentStore} />
  const mapLocationEditRow = (
    <MapLocationEditRow editing={editing} setEditing={setEditing} loading={loading} canEditStores={canEditStores} />
  )
  const latitudeRow = (
    <LocationRow
      className='detail-lat'
      label='Latitude'
      input={
        <LocationInput name='lat' message='Latitude is required' editing={editing} initialValue={currentStore.lat} />
      }
    />
  )
  const longitudeRow = (
    <LocationRow
      className='detail-long'
      label='Longitude'
      input={
        <LocationInput name='lon' message='Longitude is required' editing={editing} initialValue={currentStore.lon} />
      }
    />
  )
  const nothingMessage = (
    <NothingMessage
      className='grid-nothing'
      title='Location has not been set'
      message='Please enter the latitude and longitude points for the site'
    />
  )

  return (
    <div className='store-expand-card'>
      <Form
        form={form}
        size='small'
        onFinish={handleSave}
        onFinishFailed={ErrorNotification}
        initialValues={currentStore}
        style={{ height: '-webkit-fill-available' }}
      >
        <Row>
          <Col span={7} className='p-3'>
            {mapLocationEditRow}
            {latitudeRow}
            {longitudeRow}
          </Col>
          <Col span={17} className='google-react-map-container'>
            {currentStore.lat && currentStore.lat !== '' && currentStore.lon && currentStore.lat !== ''
              ? googleMap
              : nothingMessage}
          </Col>
        </Row>
      </Form>
    </div>
  )
}

function MapLocationEditRow({ editing, setEditing, loading, canEditStores }) {
  return (
    <Row style={{ height: '13vh' }}>
      <Col className='store-detail-header' span={20}>
        Map Location
      </Col>
      <LoadEditState loading={loading} canEditStores={canEditStores} editing={editing} setEditing={setEditing} />
    </Row>
  )
}

function LoadEditState({ loading, canEditStores, editing, setEditing }) {
  if (loading) {
    return (
      <Col align='right' span={4}>
        <LoadingOutlined />
      </Col>
    )
  }
  if (canEditStores) {
    return (
      <Col span={4} align='right'>
        <EditSaveButton editing={editing} onEdit={() => setEditing(true)} />
      </Col>
    )
  }
}

function LocationRow({ input, label, className }) {
  return (
    <Row className={className}>
      <Col span={24}>
        <DataItem label={label}>
          <Row>
            <Col span={21}>{input}</Col>
            <Col align='right' span={2} className='pb-2'>
              <EnvironmentFilled className='icon' />
            </Col>
          </Row>
        </DataItem>
      </Col>
    </Row>
  )
}

function LocationInput({ name, message, editing, initialValue, ...others }) {
  if (!editing) return initialValue
  return (
    <FormInput
      name={name}
      message={message}
      editable={editing}
      initialValue={initialValue}
      width='95%'
      required
      {...others}
    />
  )
}
